module.exports = __webpack_public_path__ + "static/media/me_wedding_compressed_cropped.6020e4f3.jpg";